(function () {
    'use strict';

    var module = angular.module('uwAgenda.email');
    module.factory('Email', ['AppConfig', 'MessageType', 'SharedAgendaService', EmailFn]);

    function EmailFn(AppConfig, MessageType, SharedAgendaService) {

        var Email = function () {

            // default values
            this.id = -1;
            this.contactInfo = ""; // contains ; - seperated values {id: title lastname} or {email}
            this.content = ""; // serialized content with attachments
            this.fK_User = null;
            this.messageDate = null;
            this.title = "";
            this.contactInfoBCC = "";
            this.messageType = MessageType.Email.value;
            this.fK_User_Sender = null;

            //internals prepare view
            this._contactInfos = [];
            this._contactInfoBCCs = [];
            this._attachments = [];

            this._fullContactInfos = [];

            // prepare for view
            function prepareView() {
                // content is json or string
                if (isJson(this.content)) {
                    var jsonContent = JSON.parse(this.content);
                    // add attachments
                    this._attachments = jsonContent.attachments;
                    // set content
                    this.content = jsonContent.content;
                }

                if (typeof this.contactInfo !== 'undefined' && this.contactInfo !== null && this.contactInfo !== "") {
                    addImageItems(this.contactInfo.split(";"), this._contactInfos);
                }
                if (typeof this.contactInfoBCC !== 'undefined' && this.contactInfoBCC !== null && this.contactInfoBCC !== "") {
                    addImageItems(this.contactInfoBCC.split(";"), this._contactInfoBCCs);
                }

                // prepare full list for view
                this._fullContactInfos = this._contactInfos.concat(this._contactInfoBCCs);
            }

            // prepare image items
            function addImageItems(items, toList) {

                var imgUrl = AppConfig.ApiUrl + "/api/images/users/{0}/false?thumbWidth=&thumbHeight=";

                angular.forEach(items, function (item) {
                    if (typeof item !== 'undefined' && item !== null && item !== "") {
                        var _splitter = ":";
                        var url;
                        // item has id
                        if (item.indexOf(_splitter) !== -1) {
                            var itemData = item.split(_splitter);

                            url = imgUrl.replace("{0}", btoa(itemData[0]));
                            addToList(toList, itemData[1], url);
                        } //if                        
                        else {
                            // default image for email
                            url = "/app/images/no-avatar.png";
                            addToList(toList, item, url);
                        }
                    }
                });
            }

            // prepare attachment items
            function addAttachmentItems(items, toList) {

                var attachmentUrl = AppConfig.ApiUrl + '/api/uploadfiles/foruser/' + "{0}/{1}";
                var keys = Object.keys(items);

                for (var i = 0; i < keys.length; i++) {
                    var item = items[keys[i]];
                    var itemName = item.substring(32, item.length);
                    var url = attachmentUrl.replace("{0}", SharedAgendaService.currentUser().id).replace("{1}", item);

                    addToList(toList, itemName, url);
                }
            }

            // prepare item for list
            function addToList(list, item, url, basePath) {
                list.push({
                    text: item,
                    url: url,
                    basePath: basePath ? basePath : false // get file from base-upload-path 
                });
            }

            // add attachement (only added on backend)
            function addAttachement(text, url, basePath) {
                addToList(this._attachments, text, url, basePath);
            }

            // check if content is json
            function isJson(str) {
                if (str === 'undefined' || str === null || str === '')
                    return false;

                try {
                    JSON.parse(str);
                } catch (e) {
                    return false;
                }
                return true;
            }

            // prepare for save build content with attachments [fileName, link]
            function prepareForSave(attachments) {
                // build contactInfo list
                if (typeof this._contactInfos !== 'undefined' && this._contactInfos !== null && Array.isArray(this._contactInfos)) {
                    this.contactInfo = this._contactInfos.join(";");
                }

                // build contactInfo bcc list
                if (typeof this._contactInfoBCCs !== 'undefined' && this._contactInfoBCCs !== null && Array.isArray(this._contactInfoBCCs)) {
                    this.contactInfoBCC = this._contactInfoBCCs.join(";");
                }

                // add attachmentlist
                addAttachmentItems(attachments, this._attachments);

                // build jsonContent with attachments
                var jsonContent = {
                    content: this.content,
                    attachments: this._attachments
                };

                this.content = JSON.stringify(jsonContent);
                // nothing to do - split into mails, -> mailcheck in db function

                // set id to null
                this.id = 0;
            }

            // default mail contactinfo 
            function addMailContactInfo(email) {
                this._contactInfos.push(email);
            }

            // default mail contactInfoBcc
            function addMailContactInfoBCC(email) {
                this._contactInfoBCCs.push(email);
            }

            // extend 
            function extend(data) {
                var self = this;
                angular.extend(self, data);
            } // extend

            //public
            this.addMailContactInfoBCC = addMailContactInfoBCC;
            this.addMailContactInfo = addMailContactInfo;
            this.prepareView = prepareView;
            this.extend = extend;
            this.prepareForSave = prepareForSave;
            this.addAttachement = addAttachement;
        };

        return Email;
    }
})();